<template>
    <div :class="['ham',{ on: on }]" @click="$emit('select','')">
        <div class="items">
            <p v-for="option in options" @click="$emit('select',option.select)">{{ option.title }}</p>
        </div>
    </div>
</template>

<script>

export default {
    props: ['on'],
    data () {
        return {
            options: [
                { title: 'About', select: 'about' },
                { title: 'Get Offers', select: 'join' },
                { title: 'Business Join', select: 'business' },
                { title: 'Contact Us', select: 'contact' },
                { title: 'Ts and Cs', select: 'terms' },
                { title: 'Unsubscribe', select: 'unsub' },
                { title: 'Login', select: 'auth' }
            ]
        }
    }
}

</script>

<style lang="scss">
.ham {
    width: 200px;
    height: 100%;
    position: absolute;
    z-index: 10;
    transition: transform 0.3s;
    transform: translateX(-200px);
    .items {
        width: 200px;
        height: calc(100% - 10px);
        background-color: black;
        border-top: 10px solid black;
        float: left;
    }
    p { color: white; padding: 10px 5px; text-decoration: underline; }
    &.on {
        width: 100%;
        background-color: rgba(100,100,100,0.05);
        transform: translateX(0px);
    }
}
</style>